import { render } from "./ow-appointments.vue?vue&type=template&id=6eb03682"
import script from "./ow-appointments.vue?vue&type=script&lang=js"
export * from "./ow-appointments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__